import { compose, withProps } from 'recompose';
import ObjectInput from './ObjectInput';
import { withLabel } from '../Label';
import PasswordInput from './PasswordInput';
import { withDescription } from '../Description';

export default withProps({
  schema: {
    newPassword: compose(
      withLabel('New Password'),
      withDescription(
        'Password must be at least 8 characters long and contain numbers, lowercase and uppercase letters'
      )
    )(PasswordInput),
    repeatedPassword: withLabel('Repeat Password')(PasswordInput),
  },
})(ObjectInput);
